import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'
interface Props {
  symbol: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    symbol: null
  },
  setup(__props: any) {

const props = __props as {
  symbol: string
}

const chainTypeHasLogo = {
  ethereum: 'eth',
  moon: 'moon',
  arweave: 'ar',
  conflux: 'cfx',
  bsc: 'bsc',
  platon: 'platon',
  moonbeam: 'moon',
  moonbase: 'moon'
}

const chainTypeLogo = computed(() => {
  if (props.symbol && props.symbol.toLowerCase() in chainTypeHasLogo) {
    return `${(chainTypeHasLogo as any)[props.symbol.toLowerCase()]}.png`
  } else {
    return 'ar.png'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: require(`@/images/network/${_unref(chainTypeLogo)}`),
    alt: "chainTypeLogo"
  }, null, 8, _hoisted_1))
}
}

})